var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackAlt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.5,9H4.5c-1.379,0-2.5,1.122-2.5,2.5v10.5h8.079l1.925,1.622c.285.253.645.379,1.001.379.352,0,.702-.123.978-.368l1.976-1.633h8.042v-10.5c0-1.378-1.121-2.5-2.5-2.5Zm1.5,12h-7.401l-2.267,1.874c-.188.168-.474.169-.674-.008l-2.214-1.865H3v-9.5c0-.827.673-1.5,1.5-1.5h17c.827,0,1.5.673,1.5,1.5v9.5Zm-3.163-6h2.163v.458l-1.648.955.663,2.015-.378.262-1.63-1.261-1.638,1.266-.36-.272.652-2.039-1.66-.924v-.003l-1.648.955.663,2.015-.378.262-1.63-1.261-1.638,1.266-.36-.272.652-2.039-1.66-.924v-.003l-1.648.955.663,2.015-.378.262-1.63-1.261-1.638,1.266-.36-.272.652-2.039-1.66-.924v-.462h2.175l.588-2.251h.486l.588,2.251h4.338l.588-2.251h.486l.588,2.251h4.338l.588-2.251h.486l.588,2.251Zm-1.837-8h-8v-1h8v1Zm-14-1h4v1h-4v-1Zm8-2H4v-1h8v1Zm6,0h-4v-1h4v1ZM2.5,1c-.827,0-1.5.673-1.5,1.5v6.206c-.616.77-1,1.733-1,2.794V2.5C0,1.122,1.121,0,2.5,0h17c1.379,0,2.5,1.122,2.5,2.5v4.5h-1V2.5c0-.827-.673-1.5-1.5-1.5H2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackAlt);
export default __webpack_public_path__ + "static/media/feedback-alt.5fdaa9dd9be68b15934623b5f109e53a.svg";
export { ForwardRef as ReactComponent };